import styled from "styled-components";
import SwipeableViews from "react-swipeable-views";

export const HeroRightContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  gap: 10px;

  @media screen and (max-width: 1024px) {
    width: 100%;
    justify-content: flex-end;
  }
  @media screen and (max-width: 430px) {
    width: 100%;
    justify-content: flex-end;
    display: none;
  }
`;

export const InnerLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 9px;
`;

export const HeroGraphics3 = styled.div`
  width: 490px;
  height: 412px;
  background-image: url("/assets/heros/Light_desktop.png");
  background-size: cover;
  background-repeat: no-repeat;

  object-fit: cover;

  @media screen and (max-width: 2560px) {
    width: 350px;
    background-image: url("/assets/heros/Light_desktop.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1920px) {
    width: 350px;
    background-image: url("/assets/heros/Light_desktop.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 1440px) {
    background-image: url("/assets/heros/Light_desktop.png");
    background-size: cover;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 768px) {
    width: 320px;
    height: 412px;
    background-image: url("/assets/heros/Light_tab.png");
    background-size: contain;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 430px) {
    width: 135px;
    height: 239.508px;
    flex-shrink: 0;
    background-image: url("/assets/heros/Light_mobile.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
  @media screen and (max-width: 375px) {
    width: 135px;
    height: 239.508px;
    flex-shrink: 0;
    background-image: url("/assets/heros/Light_mobile.png");
    background-size: contain;
    background-repeat: no-repeat;
  }
`;
export const HeroGraphics3Dark = styled.div`
  width: 350px;
  height: 412px;
  background-image: url("/assets/heros/Dark.svg");
  background-size: cover;
  background-repeat: no-repeat;
  @media only screen and (max-width: 767px) {
    width: 135px;
    height: 239.508px;
  }
`;

export const HeroGraphics2 = styled.div`
  width: 357px;
  height: 190px;
  border-radius: 10px;

  background-image: url("/assets/heros/HeroGraphics2_desktop.png");
  background-size: contain;
  background-repeat: no-repeat;
  margin-left: 70px;
  object-fit: cover;

  @media screen and (max-width: 768px) {
    width: 357px;
    height: 190px;

    background-image: url("/assets/heros/Herographics2_tab.png");
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: 70px;
  }

  @media screen and (max-width: 430px) {
    width: 207.53px;
    height: 110.45px;

    flex-shrink: 0;
    background-image: url("/assets/heros/HeroGraphics2_mobile.png");
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: 0px;
  }
  @media screen and (max-width: 375px) {
    width: 207.53px;
    height: 110.45px;

    flex-shrink: 0;
    background-image: url("/assets/heros/HeroGraphics2_mobile.png");
    background-size: contain;
    background-repeat: no-repeat;
    margin-left: 0px;
  }
`;
